import Jobs from '@/api/jobs'
import Referrals from '@/api/referrals'

export default {
  namespaced: true,
  state: {
    suggestions: [],
    selected: [],
    jobseeker: null,
    refferaldelete: {
      jobid: null,
      approve: null
    }
  },
  mutations: {
    setSelected (state, selected) {
      state.selected = selected
    },
    setJobseeker (state, user) {
      state.jobseeker = user
      state.suggestions = []
      state.selected = []
    },
    setSuggestions (state, suggestions) {
      state.suggestions = suggestions
    },
    addSelected (state, value) {
      const exists = state.selected.find((x) => value === x)
      if (!exists) {
        state.selected = state.selected.concat([value])
      }
      state.suggestions = []
    },
    setRefferaldelete (state, value) {
      state.refferaldelete = value
    }
  },
  actions: {
    async updateSuggestions ({ commit, state }, text) {
      const selectedIds = state.selected.reduce((res, x) => {
        if (x.id) {
          res[x.id] = 1
        }
        return res
      }, {})
      const jobs = await Jobs.searchVisited({ keyword: text }).then(
        xs => xs.filter((x) => selectedIds[x.id] !== 1)
      )
      commit('setSuggestions', jobs)
    },
    async submitReferrals ({ commit, state }) {
      if (!state.jobseeker) { return }
      const userId = state.jobseeker
      await Promise.all(state.selected.map(async x => {
        const jobId = x.id
        return Referrals.createUserReferral({
          jobId, userId
        })
      }))
    },
    removeReferal ({commit, state}, index) {
      const jobs = state.selected
      jobs.splice(index, 1)
      commit('setSelected', jobs)
    },
    refferaldelete ({commit}, value) {
      commit('setRefferaldelete', value)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/jobseeker-referral.js